var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurchaseIcon = function SvgPurchaseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 3h1v6H2zm5.147-.354L3.792 6l3.353 3.353.708-.707L5.707 6.5H10v-1H5.707l2.147-2.147z"
  })));
};
export { SvgPurchaseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTIgMi45OTk5OEgzVjguOTk5OThIMlYyLjk5OTk4Wk03LjE0NjUgMi42NDY0OEwzLjc5MyA1Ljk5OTk4TDcuMTQ2NSA5LjM1MzQ4TDcuODUzNSA4LjY0NjQ4TDUuNzA3IDYuNDk5OThIMTBWNS40OTk5OEg1LjcwN0w3Ljg1MzUgMy4zNTM0OEw3LjE0NjUgMi42NDY0OFoiCiAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgLz4KPC9zdmc+Cg==";